import { LabelText } from "./LabelText";

export interface LinkText extends LabelText {
  url: string;
}

export function isLinkText(item: any): item is LinkText {
  return typeof item === "object" && typeof item.url === "string";
}
